import { render, staticRenderFns } from "./ModalFormSimple.vue?vue&type=template&id=a9778b84&"
import script from "./ModalFormSimple.vue?vue&type=script&lang=js&"
export * from "./ModalFormSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports